import {Injectable} from "@angular/core";
import {FormDefinitionFieldModel} from "../../api/entity/formDefinitionField.model";
import {FormDefinitionFieldRepository} from "./ngrx/formDefinitionField.repository";
import {AbstractFindOneByIdService} from "../../../../../core/service/v2/service/findone/abstractFindOneById.service";
import {FormDefinitionFieldDataServiceAdapter} from "./ngrx/formDefinitionFieldDataService.adapter";

@Injectable()
export class FormDefinitionFieldFindOneByIdService extends AbstractFindOneByIdService<FormDefinitionFieldModel, FormDefinitionFieldModel> {

    constructor(repository: FormDefinitionFieldRepository, dataServiceAdapter: FormDefinitionFieldDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}